'use strict';

class BankTxesController {
  /* @ngInject */
  constructor(BankTxesService, ClientsService, $scope, $q, $filter) {
    Object.assign(this, {
      BankTxesService,
      ClientsService,
      $scope,
      $q,
      $filter
    });

    this.query = {
      include: [
        'client',
        {
          relation: 'paymentItem',
          scope: {
            include: {
              relation: 'receipt',
              scope: {
                include: 'employee'
              }
            }
          }
        }
      ],
      where: {},
      limit: 10,
      page: 1,
      order: 'date DESC'
    };

    this.getBankTxes();

    this.onPagination = () => {
      this.getBankTxes();
    };
  }

  getBankTxes() {
    let qOpts = JSON.parse(JSON.stringify(this.query));

    if (this.client) {
      qOpts.where = Object.assign(qOpts.where, {
        clientId: this.client.id
      });
    }

    if (this.onlyPending) {
      qOpts.where = Object.assign(qOpts.where, {
        state: {
          neq: 'approved'
        }
      });
    }

    let queryReady = this.BankTxesService.getModels(qOpts).then(bankTxes => {
      this.bankTxes = bankTxes;
    });
    let countReady = this.BankTxesService.getCount(qOpts).then(result => {
      this.bankTxesCount = result.count;
    });
    this.promise = this.$q.all([queryReady, countReady]);
    return this.promise;
  }

  querySearchClient() {
    return this.ClientsService.findByName(this.searchTextClient);
  }
}

export default BankTxesController;
